/* RANI CUSTOM — Scroll-reveal animasyon sistemi.
   Hedef elemanlara data-reveal basar, görünüme girince .is-visible ile yumuşak açar.
   JS yüklenmezse hiçbir eleman gizlenmez (attribute hiç basılmaz) — güvenli.
   prefers-reduced-motion açıksa animasyon tamamen atlanır. */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var HEDEFLER = [
    // bölüm başlıkları
    '.rani-pro-head', '.rani-firsat__baslik', '.rani-bcift__baslik', '.rani-video__baslik',
    '.wt-featured-collection .headline', '.rani-yorum-cta__baslik',
    // kart aileleri (stagger ile)
    '.rani-firsat__kart', '.rani-look', '.rani-bcift__kart',
    '.rani-kategoriler__kart, .rani-kat-kart', '.rani-video-vitrin__kart, .rani-video__kart',
    '.rani-ozellik, .rani-ozellikler__oge',
    // büyük bantlar
    '[data-rani-editorial] .rani-editorial__kutu', '.rani-serit__ic, .rani-serit__tasarim'
  ];

  var gecikmeSayaci = {};

  function hazirla(el, grupAnahtari) {
    if (el.hasAttribute('data-reveal')) return;
    var n = (gecikmeSayaci[grupAnahtari] = (gecikmeSayaci[grupAnahtari] || 0) + 1);
    el.setAttribute('data-reveal', '');
    // aynı gruptaki kartlar 60ms arayla sırayla gelsin (en fazla 8 kademe)
    el.style.transitionDelay = (Math.min(n - 1, 8) * 60) + 'ms';
  }

  function baslat() {
    var gozlemci = new IntersectionObserver(function (girisler) {
      girisler.forEach(function (g) {
        if (g.isIntersecting) {
          g.target.classList.add('is-visible');
          gozlemci.unobserve(g.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    HEDEFLER.forEach(function (sec) {
      var liste;
      try { liste = document.querySelectorAll(sec); } catch (e) { return; }
      liste.forEach(function (el) {
        // görünümdeyse (ilk ekran) animasyonsuz geç — açılışta boşluk hissi olmasın
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.9 && r.bottom > 0) return;
        hazirla(el, sec);
        gozlemci.observe(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else {
    baslat();
  }
})();

/* =====================================================================
   RANI — Mobil filtre barı takipçisi.
   Temanın --filters-sticky-offset JS'i bozuk (her durumda 0 basıyor).
   Bu takipçi --rani-filter-top'u her karede header yığınının GERÇEK alt
   kenarına eşitler: header gizlenirken/gelirken bar boşluksuz altında kalır.
   Sadece mobil (<750px) ve sadece koleksiyon sayfasında çalışır.
   ===================================================================== */
(function () {
  'use strict';
  if (!document.querySelector('.collection__sticky-header')) return;

  var mq = window.matchMedia('(max-width: 749px)');
  var raf = null;

  function tick() {
    raf = null;
    if (!mq.matches) return;
    var top = 0;
    var bar = document.querySelector('.rani-top-bar');
    var header = document.querySelector('header.page-header') || document.querySelector('.page-header');
    if (bar) {
      var b = bar.getBoundingClientRect();
      if (b.bottom > top) top = b.bottom;
    }
    if (header) {
      var h = header.getBoundingClientRect();
      if (h.bottom > top) top = h.bottom;
    }
    document.documentElement.style.setProperty('--rani-filter-top', Math.max(0, Math.round(top)) + 'px');
    raf = requestAnimationFrame(tick); // header slide animasyonunu da karesiz takip et
  }
  function start() {
    if (raf === null) raf = requestAnimationFrame(tick);
  }

  if (mq.matches) start();
  mq.addEventListener ? mq.addEventListener('change', function (e) { if (e.matches) start(); })
                      : mq.addListener(function (e) { if (e.matches) start(); });
})();
